import { useEffect, useState } from 'react';
import { CheckboxGroupFilter } from 'framework/list';
import { useOfficeService } from 'domain/shared/employee';
import Box from '@mui/material/Box';

const OfficeFilter = ({ source }: any) => {
  const { findAll } = useOfficeService();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    (async () => {
      const offices = await findAll();
      const data = offices.map((office: any) => ({
        value: office.id.toString(),
        label: office.name,
      }));
      setOptions(data);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={theme => ({
        transform: 'translateX(14px)',
        '& .MuiFormControl-root.checkbox-form-group': {
          marginBottom: 0,
        },
        [theme.breakpoints.up('sm')]: {
          marginBottom: '-30px',
        },
      })}
    >
      <CheckboxGroupFilter options={options} source={source} isColumnDirection />
    </Box>
  );
};

export default OfficeFilter;
